import React from 'react';
import EntityListFetcher from '../components/EntityListFetcher';
import typeIntro from '../static/introspection/Trend360.json';
import { ENTITY } from '../utils/entities';
import { Trend360ListQuery } from 'graphql/query/Trend360ListQuery';
import Trend360Filters from '../static/introspection/Trend360FilterInput.json';

const Trend360List = () => (
	<EntityListFetcher
		query={Trend360ListQuery}
		entityName={ENTITY.TREND_360}
		headers={['trendName', 'status']}
		sortables={['trendName', 'status']}
		typeIntro={typeIntro}
		filtersIntro={Trend360Filters}
		filterFields={['trendName', 'statuses']}
	/>
);

export { Trend360List };